import axios from "axios"
import { BANK_TYPES_ENDPOINT } from "../../../../../../utility/SourceAPI"

/**
 * Única capa que habla con el backend del catálogo de bancos.
 * Devuelve siempre `response.data`, nunca el envoltorio de axios, y deja que el
 * error suba tal cual: quien decide qué hacer con él es el thunk (rejectWithValue).
 */

export const fetchBankTypes = async () => {
    const response = await axios.get(BANK_TYPES_ENDPOINT)
    return response.data
}
